import styled from 'styled-components';

import { Color, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { TabUnderline } from '../tabs';

export const Container: StyledComponent<'div'> = styled.div``;

export const Header: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 30px;
  line-height: 38px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  margin-bottom: 12px;
`;

export const StyledTabUnderline: StyledComponent<typeof TabUnderline> = styled(TabUnderline)`
  white-space: nowrap;

  & + & {
    margin-left: 40px;
  }
`;

export const TabsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
